export default {

  setAllRequests(state, data) {
    state.allRequests = data;
  },

  setManagerAllRequests(state, data) {
    state.managerAllRequests = data;
  },

  setRemainLeaves(state, data) {
    state.remainLeaves = data;
  },

  setDailyWorks(state, data) {
    state.dailyWorks = data;
  },

  setInsuranceList(state, data) {
    state.insuranceList = data;
  },

  setInsuranceFee(state, data) {
    state.insuranceFee = data;
  },
  setInsuranceFeeTitle(state, data) {
    state.insuranceFeeTitle = data;
  },

  setSuggestionList(state, data) {
    state.suggestionList = data;
  },

  setManagerSuggestionList(state, data) {
    state.managerSuggestionList = data;
  },

  setDepartments(state, data) {
    state.departments = data;
  },

  setExpertPollHeaders(state, data) {
    state.expertPollHeaders = data;
  },
  setManagerPollHeaders(state, data) {
    state.managerPollHeaders = data;
  },
  setManagerPollsHistory(state, data) {
    state.managerPollsHistory = data;
  },
  setUserPollHeaders(state, data) {
    state.userPollHeaders = data;
  },
  setPollDetails(state, data) {
    state.pollDetails = data;
  },
  setAnswerPollHeaders(state, data) {
    state.answerPollHeaders = data;
  },
  setAnswerPollDetails(state, data) {
    state.answerPollDetails = data;
  },
  setUserAnswerPollHeaders(state, data) {
    state.userAnswerPollHeaders = data;
  },
  setUserAnswerPollDetails(state, data) {
    state.userAnswerPollDetails = data;
  },

  setUserComponentAnswers(state, data) {
    state.userComponentAnswers = data;
  },

  setPageTotal(state, data) {
    state.pageTotal = data;
  },

};
